export default __webpack_public_path__ + "static/media/SH.57288667.png";